import * as React from 'react';
import { IDropDownMenuProps } from '../../../DropDownMenu.types';
import DropDownMenuBase from '../../DropDownMenuBase';
import MenuButton from '../../../../MenuButton/viewer/skinComps/SeparateBasicMenuButtonNSkin/SeparateBasicMenuButtonNSkin';
import styles from './SeparateBasicMenuButtonSkin.scss';

const SeparateBasicMenuButtonSkin: React.FC<IDropDownMenuProps> = props => {
  return <DropDownMenuBase {...props} styles={styles} Button={MenuButton} />;
};

export default SeparateBasicMenuButtonSkin;
